import { WEBVIEW } from '../constants/string'

export const getWebviewId = webviewSrc => {
  if (!webviewSrc) {
    return
  }

  const webviewSrcArray = webviewSrc.split('/')
  const indexWebview = webviewSrcArray.findIndex(item => item === WEBVIEW)

  // get webview id
  return webviewSrcArray[indexWebview + 1]
}
